import { render, staticRenderFns } from "./Portalinformationen.vue?vue&type=template&id=09caa7b4&scoped=true&"
import script from "./Portalinformationen.vue?vue&type=script&lang=js&"
export * from "./Portalinformationen.vue?vue&type=script&lang=js&"
import style0 from "./Portalinformationen.vue?vue&type=style&index=0&id=09caa7b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09caa7b4",
  null
  
)

export default component.exports